<app-loader *ngIf="searching && !users"></app-loader>

<div *ngIf="users && users.length === 0">
  <p>No users to display</p>
</div>

<div *ngIf="users && users.length > 0">
  <div class="geo-permit-table-wrapper" *ngIf="!templateForPermitForm">
    <table class="table">
      <tr>
        <td></td>
        <th>Full Name</th>
        <th>Username</th>
        <th>Email</th>
        <th>Last Activity Date</th>
      </tr>
      <tr *ngFor="let user of users">
        <td>
          <a href="#" (click)="editUser(user)" style="cursor: pointer;"
            >Select</a
          >
        </td>
        <td>
          {{ user.name }}
        </td>
        <td>
          {{ user.userName }}
        </td>
        <td>
          {{ user.emailAddress }}
        </td>
        <td>
          {{ user.lastActivityDate | date: 'MM/dd/yyyy hh:mm aa' }}
        </td>
      </tr>
    </table>
  </div>

  <!--    added by priya 03-12-2025  
 -->
  <div class="table-content" *ngIf="templateForPermitForm">
    <div class="table-header">
      <div>Action</div>
      <div>Full Name</div>
      <div>Username</div>
      <div>Email</div>
      <div>Last Activity Date</div>
    </div>

    <div *ngFor="let user of users" class="table-row">
      <div>
        <a (click)="editUser(user)" class="link-color">Select</a>
      </div>
      <div>{{ user.name }}</div>
      <div>{{ user.userName }}</div>
      <div>{{ user.emailAddress }}</div>
      <div>{{ user.lastActivityDate | date: 'MM/dd/yyyy hh:mm aa' }}</div>
    </div>
  </div>
  <!--    end by priya 03-12-2025  
 -->
</div>
